import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, TrendingDownIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-274">
      <div className="max-w-4xl mx-auto px-4" data-id="element-275">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-276">
          <div className="text-center mb-10" data-id="element-277">
            <span className="inline-flex items-center gap-2 text-[#C4A962] text-sm font-medium uppercase tracking-wider mb-4" data-id="element-278">
              <SparklesIcon className="w-4 h-4" data-id="element-279" />
              Resultados Reales
              <SparklesIcon className="w-4 h-4" data-id="element-280" />
            </span>
            <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl font-bold text-[#2D3436]" data-id="element-281">
              Lo que puedes esperar
            </h2>
          </div>

          {/* Main stat card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-gradient-to-br from-[#FBF9F4] to-white rounded-3xl p-8 md:p-12 border border-[#C4A962]/20 shadow-lg mb-8" data-id="element-282">
            <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10" data-id="element-283">
              <div className="flex-shrink-0 w-20 h-20 bg-[#5B8F7B] rounded-full flex items-center justify-center" data-id="element-284">
                <TrendingDownIcon className="w-10 h-10 text-white" data-id="element-285" />
              </div>
              <div className="text-center md:text-left" data-id="element-286">
                <p className="text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#5B8F7B] mb-2" data-id="element-287">
                  2-3 pulgadas
                </p>
                <p className="text-lg text-[#2D3436]/70" data-id="element-288">
                  de reducción visible en la zona abdominal en solo 7 días
                </p>
              </div>
            </div>
          </motion.div>

          {/* Explanation */}
          <div className="bg-[#5B8F7B]/5 rounded-2xl p-6 md:p-8" data-id="element-289">
            <p className="text-lg text-[#2D3436] leading-relaxed mb-4" data-id="element-290">
              En solo 7 días, la mayoría de las mujeres reportan una reducción
              visible de 2 a 3 pulgadas en la zona abdominal y una{' '}
              <span className="font-semibold text-[#5B8F7B]" data-id="element-291">
                claridad mental que no sentían hace años
              </span>
              .
            </p>
            <p className="text-lg text-[#2D3436]/80 leading-relaxed" data-id="element-292">
              No es magia, es <em data-id="element-293">neurobiología aplicada a tu nutrición</em>. Al
              reducir el cortisol, tu cuerpo finalmente "suelta" lo que ha
              estado reteniendo por protección.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}